// import config from '@/config'
import store from '@/store'
import Account from '@/components/mixins/Account'
import GeoLocation from '@/components/mixins/GeoLocation'
import Screen from '@/components/mixins/Screen'
import config from '@/config'
import mobileBridge from '@/library/mobileBridge'
import moment from 'moment'

export default {
  mixins: [
    Account,
    GeoLocation,
    Screen
  ],
  data () {
    return {
      randomInterval: false,
      excludeTitleDisplayByGroupType: ['MKJ'],
      specialGroupTypes: {
        'mkj': 'CasinoMarketingJackpots',
        'tmu': 'CasinoTopGames',
        'tcp': 'CasinoTopGames',
        'tmw': 'CasinoTopGames',
        'tml': 'CasinoTopGames'
      },
      jackpotIntervalId: null,
      marketingJackpotIntervalId: null,
      marketingJackpotData: false,
      marketingJackpotLevelsData: [],
      now: new Date()
    }
  },
  computed: {
    allGames () {
      return store.getters['gap/getAllGamesData']
    },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    hashedUserId () {
      return store.getters['getUid'] || localStorage.customer
    },
    user () {
      return store.getters['getCustomerContext'] ? store.getters['getCustomerContext'].User : undefined
    },
    allJackpots () {
      return store.getters['gap/getAllJackpotsData']
    },
    mgProgress () {
      return store.getters['getMobileGeolocationInProgress']
    },
    jackpotValuesFromLS () {
      return store.getters['gap/getJackpotsFromLocalStorage']
    },
    dateFormats () {
      return config.app.dateFormats
    },
    marketingJackpots () {
      return store.getters['gap/getMarketingJackpots']
    },
    allFavoriteGames () {
      return store.getters['gap/getFavoriteGames']
    }
  },

  methods: {
    startCasinoLauncher (id) {
      if (!this.isLoggedIn) {
        this.loginPopUp()
        store.commit('gap/setLaunchGameWithGameIdAfterLogin', id)
        return false
      }
      if (!this.isGeolocated) {
        if (!window.ctsautoconf.MOBILE_LS && !this.mobileBigAndBelow) this.viewGeoLocationDetails()
        if (window.ctsautoconf.MOBILE_LS) mobileBridge.bridgeSendRequest('showLocationMessage', this.mgProgress.id)
        if (!window.ctsautoconf.MOBILE_LS && this.mobileBigAndBelow) {
          store.commit('overlayState/setMessageDialogMsg', { reason: 'native-app-casino', persistent: true, options: { oncloseredirecttohome: false } })
          store.dispatch('overlayState/activateMessageDialog')
        }
        store.commit('gap/setLaunchGameWithGameIdAfterLogin', false)
        return false
      }
      store.dispatch('gap/fetchSecureToken').then((response) => {
        if (id && response && response.token) {
          let token = response.token
          let userId = this.hashedUserId
          let username = this.user
          let userCurrencyCode = this.userCurrencyCode
          store.commit('gap/setLaunchGameWithGameIdAfterLogin', false)
          store.dispatch('overlayState/activateCasinoLauncherDialog', {id, token, userId, username, userCurrencyCode}).then(r => console.log('startCasinoLauncher success', r))
          let event = {
            'event': 'casino_game_launch_start',
            'gaEventAction': 'casino_game_launch_start',
            'gaGameId': id || 'N/A',
            'accountId': localStorage.customer || 'N/A'
          }
          let xtremeObj = {
            'param1': 'event',
            'param2': 'casino_game_launch_start',
            'param3': {
              'gameId': id,
              'accountId': localStorage.customer || 'N/A'
            }
          }
          this.updateAnalytics(event, xtremeObj)
        }
      }).catch(err => console.log('CASINO token error:', err))
      // store.dispatch('overlayState/activateCasinoLauncherDialog', id).then(r => console.log('startCasinoLauncher success', r))
    },
    loginPopUp () {
      store.dispatch('overlayState/activateLoginDialog')
    },
    findGameData (id) {
      id = parseInt(id)
      if (this.allGames && this.allGames.games && this.allGames.games.length > 0) {
        return this.allGames.games.find(g => g.id === id)
      }
    },
    findGroupData (data) {
      if (this.allGames && this.allGames.groups && this.allGames.groups.length > 0) {
        return this.allGames.groups.find(g => {
          return g['slug'] === data
        })
      }
    },
    sortUrl (url) {
      let path = url.endsWith('/') ? url.slice(0, -1) : url
      if (path.indexOf('http://') > -1 || path.indexOf('https://') > -1) {
        return path
      } else {
        if (path.indexOf('//') !== 0) {
          path = '//' + path
        }
        return path
      }
    },
    clientSideSearch () {
      let phase = store.getters['gap/getPhrase']
      // let providerNames = this.allGames.providers
      let searchFilter = this.allGames.games.filter(game => game.name.toLowerCase().includes(phase))
      let parseData = []
      parseData['groupId'] = searchFilter.length + Math.random()
      parseData['gameIds'] = []
      for (let i = 0; i < searchFilter.length; i++) {
        parseData['gameIds'].push(searchFilter[i].id)
      }
      store.commit('gap/setResults', parseData)
    },
    getGameInfo (id) {
      return store.dispatch('gap/fetchGameInfo', id)
    },
    updateAnalytics (event, xtremeObj) {
      if ((window.dataLayer && !window.ctsautoconf.MOBILE_LS) || window.xtremepush || (config.app.autoconf.XTREMEPUSH_ANALYTICS && window.ctsautoconf.MOBILE_LS)) {
        store.dispatch('analyticsHandler', {'event': event, 'xtremeObj': xtremeObj}, { root: true })
      }
    },
    setJackpotIfAvailableForThisGame (gameId, section = false) {
      setTimeout(() => {
        if (!this.allJackpots || Object.keys(this.allJackpots).length === 0) return false
        for (const [key, value] of Object.entries(this.allJackpots)) {
          if (key === gameId) {
            this.sortJackpotPerCurrency(value, gameId, section)
            break
          }
        }
      }, 0)
    },
    sortJackpotPerCurrency (value, gameId, section) {
      for (const val of value) {
        if (val.currencyId === this.userCurrencyCode) {
          let jackpotData = {
            'currencyId': val.currencyId,
            'maxAmount': val.maxAmount
          }
          this.addJackpotToLocalStorage(jackpotData, gameId, section)
          this.startJackpotCounter(jackpotData, gameId, section)
          break
        }
      }
    },
    startJackpotCounter (jackpotData, gameId, section) {
      let reducedAmount = parseFloat((jackpotData.maxAmount - (jackpotData.maxAmount * 0.02)).toFixed(2)) // Apply a 2% reduction to the maximum jackpot amount and initiate the jackpot increase simulation.
      let startJackpotAmount = false
      if (this.jackpotValuesFromLS) {
        if (this.jackpotValuesFromLS.length > 0) {
          for (let i = 0; i < this.jackpotValuesFromLS.length; i++) {
            if (parseInt(this.jackpotValuesFromLS[i].id) === parseInt(gameId)) {
              if (this.jackpotValuesFromLS[i].amount === '') {
                startJackpotAmount = reducedAmount.toString()
              } else {
                startJackpotAmount = this.jackpotValuesFromLS[i].amount
              }
              this.jackpotValuesFromLS[i].amount = reducedAmount.toString()
              store.commit('gap/setJackpotsFromLocalStorage', this.jackpotValuesFromLS)
            }
          }
        }
      } else {
        startJackpotAmount = reducedAmount
      }
      let finalJackpotAmount = parseFloat(jackpotData.maxAmount)
      let currentJackpotAmount = startJackpotAmount
      this.updateJackpot(gameId, startJackpotAmount, section, jackpotData.currencyId)
      let existsInLocalStorage = this.jackpotValuesFromLS.some(item => parseInt(item.id) === parseInt(gameId))
      if (existsInLocalStorage) {
        const checkJackpotIntervalStatus = this.jackpotValuesFromLS.filter(item => item.id === gameId)
        if (checkJackpotIntervalStatus[0].isActive === '') {
        } else {
          return false
        }
      }
      this.startInterval(finalJackpotAmount, currentJackpotAmount, startJackpotAmount, gameId, section, jackpotData.currencyId)
    },
    startInterval (finalJackpotAmount, currentJackpotAmount, startJackpotAmount, gameId, section, currency) {
      let randomIntervalTimer = false
      randomIntervalTimer = (Math.floor(Math.random() * (10 - 2 + 1)) + 2) * 1000 // random interval between 2-10 seconds.
      let randomDecimalNumber = 0
      // let randomDecimalNumber = (Math.floor(Math.random() * 15) + 1) / 10 // add random decimal for better UX.
      let randomJackpotIncreaseNumber = parseFloat((Math.floor(Math.random() * (500 - 100 + 1)) + 100)) + randomDecimalNumber // increase the jackpot amount with random number between 100-500.
      this.randomInterval = setInterval(() => {
        let sum = parseFloat(currentJackpotAmount) + randomJackpotIncreaseNumber
        if (sum > finalJackpotAmount) {
          currentJackpotAmount = parseFloat(finalJackpotAmount)
          clearInterval(this.randomInterval)
          this.randomInterval = false
          return false
        } else {
          currentJackpotAmount = parseFloat(sum).toFixed(2)
          for (let i = 0; i < this.jackpotValuesFromLS.length; i++) {
            if (parseInt(this.jackpotValuesFromLS[i].id) === parseInt(gameId)) {
              startJackpotAmount = currentJackpotAmount
              this.jackpotValuesFromLS[i].amount = currentJackpotAmount
              this.jackpotValuesFromLS[i].isActive = true
              store.commit('gap/setJackpotsFromLocalStorage', this.jackpotValuesFromLS)
            }
          }
        }
        clearInterval(this.randomInterval)
        this.randomInterval = null
        this.updateJackpot(gameId, startJackpotAmount, section, currency)
        this.startInterval(finalJackpotAmount, currentJackpotAmount, startJackpotAmount, gameId, section, currency)
      }, randomIntervalTimer)
    },
    updateJackpot (gameId, startJackpotAmount, section, currency) {
      let getParentElem = document.getElementsByClassName('jackpot-holder-' + gameId)
      if (getParentElem && getParentElem.length > 0) {
        let getBox = false
        for (let i = 0; i < getParentElem.length; i++) {
          getBox = getParentElem[i].getElementsByClassName('jackpot-box')
          if (getBox.length > 0) {
            getBox[0].classList.remove('hidden')
            let getJackpotCurrencyElem = getBox[0].getElementsByClassName('jackpot-currency')
            if (getJackpotCurrencyElem) getJackpotCurrencyElem[0].innerText = currency === 'USD' ? '$' : 'M$'
            let getJackpotAmountElem = getBox[0].getElementsByClassName('jackpot-amount')
            if (getJackpotAmountElem) getJackpotAmountElem[0].innerText = this.formatJackpotNumber(startJackpotAmount)
          }
        }
      }
    },
    onComponentDestroyedCheckIsJackpotVisibleAnywhere (gameId) {
      if (this.randomInterval) {
        let findGameJackpotHolder = document.getElementsByClassName('jackpot-holder-' + gameId)
        if (findGameJackpotHolder) return false
        clearInterval(this.randomInterval)
        this.randomInterval = false
      }
    },
    addJackpotToLocalStorage (jackpotData, gameId, section) {
      let parseCasinoJackpots = this.jackpotValuesFromLS
      let exists = parseCasinoJackpots.some(item => parseInt(item.id) === parseInt(gameId))
      if (!exists) {
        parseCasinoJackpots.push({
          'id': gameId.toString(),
          'amount': '',
          'section': section,
          'isActive': ''
        })
        store.commit('gap/setJackpotsFromLocalStorage', parseCasinoJackpots)
      }
    },
    setGroupSliderItemLimit (group, section = false) {
      let newObj = []
      if (group && group.displayCount && !section) {
        newObj['displayCount'] = group.displayCount
        newObj['groupId'] = group.groupId
        newObj['groupName'] = group.groupName
        newObj['gameIds'] = group.gameIds.slice(0, parseInt(group.displayCount))
        return newObj
      }
      if (group && section && section) {
        newObj['displayCount'] = group.games.length
        newObj['groupId'] = this.generateUniqueId()
        newObj['groupName'] = section
        newObj['gameIds'] = group.games.map(item => item.id)
        return newObj
      }
      return group
    },
    generateUniqueId () {
      const timestamp = Date.now()
      const randomNumber = Math.floor(Math.random() * 10000)
      const formattedRandomNumber = String(randomNumber).padStart(5, '0')
      return `${timestamp}${formattedRandomNumber}`
    },
    onHoverStart (e) {
      if (this.mobileBigAndBelow) return false
      const element = e.target
      const classList = element.classList
      element.style.transform = 'translateY(-10px)'
      if (classList.contains('top-ten-item')) {
        const allTopTenItems = document.querySelectorAll('.top-ten-item')
        this.hideAllExceptHoveredItem(allTopTenItems, element, 'add')
      }
    },
    onHoverEnd (e) {
      if (this.mobileBigAndBelow) return false
      const element = e.target
      const classList = element.classList
      element.style.transform = 'translateY(0)'
      if (classList.contains('top-ten-item')) {
        const allTopTenItems = document.querySelectorAll('.top-ten-item')
        this.hideAllExceptHoveredItem(allTopTenItems, element, 'remove')
      }
    },
    hideAllExceptHoveredItem (allTop10Items, el, addOrRemove) {
      allTop10Items.forEach(item => {
        const topImg = item.getElementsByClassName('top-image')
        const parent = topImg[0].parentElement
        if (item !== el) {
          if (topImg[0] && addOrRemove === 'remove') {
            topImg[0].classList.remove('hide-on-hover')
            parent.classList.remove('lower-opacity')
          } else if (topImg[0] && addOrRemove === 'add') {
            topImg[0].classList.add('hide-on-hover')
            parent.classList.add('lower-opacity')
          }
        } else {
          topImg[0].style.transform = 'translateY(-5px)'
        }
      })
    },
    filterGamesInfoDataByGroup (gameIds) {
      if (!this.allGames || !Array.isArray(this.allGames.games) || !Array.isArray(gameIds)) return []
      return gameIds
        .map(id => this.allGames.games.find(g => String(g.id) === String(id)))
        .filter(Boolean)
    },
    getGameInfoDataByGameId (games, gameId, groupName) {
      if (games && gameId) return games.find(game => game.id === gameId)
      return false
    },
    isGroupTitleInExcludedList (groupType) {
      if (!groupType) return false
      return !this.excludeTitleDisplayByGroupType.includes(groupType)
    },
    checkIsSpecialGroupType (groupType, id) {
      let gType = (groupType && groupType.toLowerCase()) || false
      if (!gType) this.specialGroupType = false
      this.specialGroupType = this.specialGroupTypes[gType] || false
    },
    // goToGamePortalPath (group) {
    //   let groupName = group.groupName.replace(/\s+/g, '-')
    //   groupName = groupName.toLowerCase()
    //   return { name: 'casino-page', params: { groupName: groupName, groupId: group.groupId } }
    // },
    // convertToKebabCase (string) {
    //   if (!string) return false
    //   return string.trim().toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, '-')
    // },
    generateLevelId (level) {
      const kebabName = level.name.toLowerCase().replace(/\s+/g, '-')
      const start = new Date(level.startTime).getTime()
      const end = new Date(level.endTime).getTime()
      return `${kebabName}-${start}-${end}`
    },
    setDateTimeForJackpot (startTime, endTime, now) {
      now = now || this.now
      const start = new Date(startTime)
      const end = new Date(endTime)
      let countdown = false
      let formatedDate = false
      let isStartTime = false
      let target
      if (start > now) {
        target = start
        isStartTime = true
      } else {
        target = end
        isStartTime = false
      }
      const format = this.dateFormats.shortDateTime
      formatedDate = moment(target).format(format)
      const diffMs = target - now
      const msInDay = 24 * 60 * 60 * 1000

      if (diffMs > 0 && diffMs <= 5 * msInDay) {
        if (diffMs < msInDay) {
          const hours = Math.floor(diffMs / (60 * 60 * 1000))
          const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000))
          countdown = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`
        } else {
          const days = Math.floor(diffMs / msInDay)
          const hours = Math.floor((diffMs % msInDay) / (60 * 60 * 1000))
          const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000))
          countdown = `${String(days).padStart(2, '0')}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`
        }
      } else {
        this.countdown = null
      }
      return {
        countdown: countdown,
        formatedDate: formatedDate,
        isStartTime: isStartTime
      }
    },
    getCurrency (jackpotCurrency) {
      return jackpotCurrency[this.userCurrencyCode]
    },
    getCurrencySymbol () {
      return this.userCurrencyCode === 'USD' ? '$' : 'M$'
    },
    getSimulatedMarketingJackpot (startTime, endTime, finalJackpot, updatedJackpot = false, minPercent = 0.05) {
      const finalValue = this.getCurrency(finalJackpot)
      const now = new Date()
      const start = new Date(startTime)
      const end = new Date(endTime)
      let currentJackpot
      if (updatedJackpot) {
        currentJackpot = updatedJackpot
      } else if (now < start) {
        const minStart = finalValue * minPercent
        const jitter = (Math.random() - 0.5)
        currentJackpot = minStart + jitter
      } else if (now >= end) {
        currentJackpot = finalValue
      } else {
        const totalDuration = end - start
        const elapsed = now - start
        const progress = elapsed / totalDuration
        const minStart = finalValue * minPercent
        currentJackpot = minStart + (finalValue - minStart) * progress
        const jitter = (Math.random() - 0.5)
        currentJackpot += jitter
      }
      if (currentJackpot > finalValue) currentJackpot = finalValue
      return {
        rowNumber: currentJackpot,
        formatedNumber: this.formatJackpotNumber(currentJackpot)
      }
    },
    startJackpotUpdater () {
      if (this.marketingJackpotIntervalId) return false
      this.marketingJackpotIntervalId = setInterval(() => {
        this.now = new Date()
        this.updateLevelsData()
      }, 3000)
    },
    stopJackpotUpdater () {
      if (this.marketingJackpotIntervalId) {
        clearInterval(this.marketingJackpotIntervalId)
        this.marketingJackpotIntervalId = null
      }
    },
    initMarketingJackpotLevelsData () {
      const savedJackpots = JSON.parse(localStorage.getItem('mar_jackpots') || false)
      const now = new Date()
      this.marketingJackpotLevelsData = this.marketingJackpotData.levels.map(level => {
        let dateInfo = this.setDateTimeForJackpot(level.startTime, level.endTime, now)
        const getLevelId = this.generateLevelId(level)
        let savedLevel = savedJackpots && savedJackpots.find(item => item.levelId === getLevelId)
        let levelId = (savedLevel && savedLevel.levelId) || this.generateLevelId(level)
        let updatedJackpot = savedLevel && savedLevel.jackpot
        let jackpot = this.getSimulatedMarketingJackpot(level.startTime, level.endTime, level.currentValue, updatedJackpot)
        this.onJackpotUpdated(levelId, jackpot.rowNumber)
        return {
          ...level,
          ...dateInfo,
          jackpot,
          currencySymbol: this.getCurrencySymbol(),
          maxJackpotByCurrency: this.getCurrency(level.currentValue),
          levelId
        }
      })
    },
    updateLevelsData () {
      const now = new Date()
      this.marketingJackpotLevelsData.forEach((level, index) => {
        const dateInfo = this.setDateTimeForJackpot(level.startTime, level.endTime, now)
        this.$set(this.marketingJackpotLevelsData[index], 'formatedDate', dateInfo.formatedDate)
        this.$set(this.marketingJackpotLevelsData[index], 'countdown', dateInfo.countdown)

        if (!level || typeof level.jackpot.rowNumber !== 'number' || typeof level.maxJackpotByCurrency !== 'number') return
        const minIncrement = 0.05
        const maxIncrement = 1.5

        const remaining = level.maxJackpotByCurrency - level.jackpot.rowNumber
        if (remaining <= 0) return
        const increment = Math.min(
          minIncrement + Math.random() * (maxIncrement - minIncrement),
          remaining
        )
        level.jackpot.rowNumber += increment
        this.$set(this.marketingJackpotLevelsData[index].jackpot, 'rowNumber', level.jackpot.rowNumber)
        this.$set(this.marketingJackpotLevelsData[index].jackpot, 'formatedNumber', this.formatJackpotNumber(level.jackpot.rowNumber))
        this.onJackpotUpdated(level.levelId, level.jackpot.rowNumber)
      })
    },
    sortGames (n) {
      if (Array.isArray(this.preparedData)) {
        const areArraysEqualOrSameLength = this.originalPreparedData.length === this.preparedData.length || JSON.stringify(this.originalPreparedData) === JSON.stringify(this.preparedData)
        let sorted = [...this.preparedData]
        if (n === 'asc') {
          sorted.sort((a, b) => a.name.localeCompare(b.name))
        }
        if (n === 'desc') {
          sorted.sort((a, b) => b.name.localeCompare(a.name))
        }
        if (n === 'default') {
          sorted = areArraysEqualOrSameLength ? this.originalPreparedData : this.preparedData
        }
        if (this.groupData) {
          this.groupData = {
            ...this.groupData,
            gameIds: sorted.map(g => g.id)
          }
          this.preparedData = sorted.slice()
          this.componentKey = Math.random()
        }
        if (this.searchResults) {
          this.searchResults = {
            ...this.searchResults,
            gameIds: sorted.map(g => g.id)
          }
          this.componentKey = Math.random()
        }
      }
    },
    filterSelected (data) {
      const areArraysEqual = JSON.stringify(this.originalPreparedData) === JSON.stringify(this.preparedData)
      if (areArraysEqual && data.reset && !data.apply) {
        this.selectedFilterNumberDisplay = false
        if (this.filteredItems && this.filteredItems.length > 0) this.filteredItems = []
        return
      }
      const hasProviderFilter = data.selected.providers.length > 0
      const hasThemeFilter = data.selected.themes.length > 0
      this.selectedFilterNumberDisplay = data.selected.themes.length + data.selected.providers.length

      // Reset
      if (data.reset || (!hasThemeFilter && !hasThemeFilter && !areArraysEqual)) {
        this.filteredItems = []
        this.selectedFilterNumberDisplay = false
        this.preparedData = [...this.originalPreparedData]
        if (data.pageSection === 'search') {
          this.searchResults = {
            ...this.searchResults,
            gameIds: this.originalPreparedData.map(g => g.id)
          }
          this.componentKey = Math.random()
          return
        }
        if (this.groupData) {
          this.groupData = {
            ...this.groupData,
            gameIds: this.originalPreparedData.map(game => game.id)
          }
          this.componentKey = Math.random()
          return
        }
      }
      // Apply filters
      if ((this.filteredItems && this.filteredItems.length > 0) && data.apply && (hasProviderFilter || hasThemeFilter)) {
        if (this.groupData) {
          this.groupData = {
            ...this.groupData,
            gameIds: this.filteredItems.map(game => game.id)
          }
          this.preparedData = [...this.filteredItems]
          this.componentKey = Math.random()
          return
        }
      }
      // Calculate filtered games
      let filteredGames = false
      filteredGames = this.originalPreparedData.filter(game => {
        const matchesProvider = !hasProviderFilter || data.selected.providers.includes(game.providerId)
        const matchesTheme = !hasThemeFilter || data.selected.themes.includes(game.theme)
        return matchesProvider && matchesTheme
      })
      this.filteredItems = [...filteredGames]
      if (data && data.pageSection && data.pageSection === 'search' && data.apply) {
        this.searchResults = {
          ...this.searchResults,
          gameIds: this.filteredItems.map(g => g.id)
        }
        this.componentKey = Math.random()
      }
    },

    formatJackpotNumber (num) {
      num = typeof num === 'string' && !isNaN(num) ? Number(num) : num
      return num.toLocaleString(this.dateFormats.locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    isInFavorite (gameId) {
      const favorites = this.allFavoriteGames ? this.allFavoriteGames.games : []
      if (!favorites.length) {
        return false
      }
      return favorites.some(game => game.id === gameId)
    },
    setExternalNavigationTarget (id, target) {
      setTimeout(() => {
        if (id) {
          document.getElementById(id).setAttribute('target', target)
        }
      }, 0)
    },
    getThemeListByCasinoPage (games) {
      if (!games) return false
      return [...new Set(games.map(game => game.theme))].map(theme => ({id: theme, name: theme}))
    },
    toCapitalCase (str) {
      if (!str) return ''
      return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
    }
  },

  mounted () {},
  watch: {}
}



// WEBPACK FOOTER //
// ./src/components/mixins/Casino.js